export const getCaseGranulometryEditOutdoorsTriggerId = (caseLabel: string) =>
  `case${caseLabel}EditOutdoorsTrigger`;
